import React, { useState, useEffect } from "react";
import "./Store_location.css";

import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { faLocationDot, faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-regular-svg-icons";
import { getLocateStore } from "../../features/home/homeSlice";
import { useSelector, useDispatch } from "react-redux";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png",
});

const ChangeMapView = ({ center, zoom }) => {
  const map = useMap();

  useEffect(() => {
    if (center) {
      map.setView(center, zoom);
    }
  }, [center, zoom, map]);

  return null;
};



const Store_location = () => {
  const locations = [
    { name: "", lat: 17.0593767004062, lng: 73.63139111084759 },
    { name: "", lat: 16.989162279760134, lng: 73.32293155600934 },
    { name: "", lat: 16.884564230968966, lng: 73.35720145087113 },
    { name: "", lat: 16.953094041364587, lng: 73.3024438202332 },
    { name: "", lat: 16.98800548035692, lng: 73.36919904273508 },
    { name: "", lat: 17.140043815618625, lng: 73.56161564464016 },
    { name: "", lat: 16.99339718007177, lng: 73.30619217600534 },
    { name: "", lat: 17.006249581802773, lng: 73.33262927269202 },
    { name: "", lat: 16.990424675361545, lng: 73.37274641315611 },
    { name: "", lat: 17.519637171176953, lng: 73.5462762673317 },
  ];

  const locationlist = [
    {
      logoimg: "/assets/images/logo/logo.png",
      companyname: "Majesty Mattress Store",
      address: "Bavdhan, Pune, Maharashtra",
      contactno: "9876543210",
      time: "10am-6pm",
    },
    {
      logoimg: "/assets/images/logo/logo.png",
      companyname: "Majesty Mattress Store",
      address: "Bavdhan, Pune, Maharashtra",
      contactno: "9876543210",
      time: "10am-6pm",
    },
    {
      logoimg: "/assets/images/logo/logo.png",
      companyname: "Majesty Mattress Store",
      address: "Bavdhan, Pune, Maharashtra",
      contactno: "9876543210",
      time: "10am-6pm",
    },
    {
      logoimg: "/assets/images/logo/logo.png",
      companyname: "Majesty Mattress Store",
      address: "Bavdhan, Pune, Maharashtra",
      contactno: "9876543210",
      time: "10am-6pm",
    },
  ];


  const formatTo12Hour = (timeStr) => {
  if (!timeStr) return "";
  const [hours, minutes] = timeStr.split(":");
  const date = new Date();
  date.setHours(+hours);
  date.setMinutes(+minutes);
  return date.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

  const dispatch = useDispatch();

  const locate_store = useSelector((state) => state.home.locatestores);

  useEffect(() => {
    dispatch(getLocateStore());
  }, [dispatch]);

  console.log(locate_store, "app set up lat long");

  // const mapSrc = `https://www.google.com/maps/embed/v1/view?key=AIzaSyCWt0FnbB9xGeabZoAMIu_c3hsMg1rKctc&center=${app_setup?.lat},${app_setup?.long}&zoom=14&maptype=roadmap`;
  // const mapSrc = `https://www.google.com/maps/embed/v1/view?key=AIzaSyCWt0FnbB9xGeabZoAMIu_c3hsMg1rKctc&center=18.5135,73.7699&zoom=14&maptype=roadmap`;

  const mapSrc = `https://maps.google.com/maps?q=${locate_store?.lat},${locate_store?.long}&z=15&output=embed`;

  console.log("MAP URL:", mapSrc);

  return (
    <>
      <section className="Store_location_sec">
        <div className="bannerdiv">
          <img
            className="bannerimg"
            src={
              process.env.PUBLIC_URL +
              "/assets/images/locate-strore/store-location.png"
            }
          />
        </div>
        <div className="container my-md-5 my-3">
          <div className="storesec">
            <div className="row">
              <div className="col-xl-4 col-md-6 mb-md-0 mb-5">
                <div className="listsec">
                  {locate_store.map((data, index) => (
                    <div className="locationbox">
                      <div className="d-flex align-items-center mb-2">
                        <div className="logodiv">
                          <img
                            className="logoimg"
                            src={process.env.REACT_APP_IMG_URL + data?.image}
                          />
                        </div>
                        <div className="namediv">
                          <h6 className="compname">{data?.name}</h6>
                        </div>
                      </div>

                      <div className="d-flex mb-2">
                        <div className="icondiv">
                          <FontAwesomeIcon icon={faLocationDot} />
                        </div>
                        <div>
                          <p className="infop">{data?.address}</p>
                        </div>
                      </div>
                      <div className="d-flex mb-2">
                        <div className="icondiv">
                          <FontAwesomeIcon icon={faPhone} />
                        </div>
                        <div>
                          <p className="infop">{data?.contact_no}</p>
                        </div>
                      </div>
                      <div className="d-flex">
                        <div className="icondiv">
                          <FontAwesomeIcon icon={faClock} />
                        </div>
                        <div>
                          <p className="infop">
                            {formatTo12Hour(data?.from)}
                            {" - "}
                            {formatTo12Hour(data?.to)}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="col-xl-8 col-md-6">
                <div className="mapsec">
                  <MapContainer
                    center={[16.9902, 73.312]}
                    zoom={10}
                    className="mapsection"
                  >
                    <ChangeMapView
                      center={
                        locate_store?.length > 0
                          ? [
                              Number(locate_store[0]?.lat),
                              Number(locate_store[0]?.long),
                            ]
                          : [16.9902, 73.312]
                      }
                      zoom={12}
                    />

                    <TileLayer
                      attribution="&copy; OpenStreetMap contributors"
                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />

                    {locate_store?.map((loc, index) => {
                      if (!loc?.lat || !loc?.long) return null;

                      return (
                        <Marker
                          key={index}
                          position={[Number(loc?.lat), Number(loc?.long)]}
                        >
                          <Popup>
                            <div>
                              <p><span>Name: {" "}</span>{loc?.name}</p>
                              <p>Address: {" "}{loc?.address}</p>
                              <p>Contact: {" "}{loc?.contact_no}</p>
                            </div>
                          </Popup>
                        </Marker>
                      );
                    })}
                  </MapContainer>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Store_location;
